import YSellerModal from './SellerModal';

export { YSellerModal };
export default YSellerModal;
